import Swiper from 'swiper';
import { find } from '../utils/dom';

const initializeSwiperSobMedida = () => {
  const container = document.querySelector('.SwiperCards');
  if (!container) return;

  const $config = {
    numeracao: find(".swiper-numeracao-cards-ativo"),
    setNumeracao: (_n) => {
      $config.numeracao.innerText = (_n < 10) ? "0" + _n : _n;
    },
    numeracaoTotal: find(".swiper-numeracao-cards-total"),
    setNumeracaoTotal: () => {
      const bullets = document.querySelectorAll(".swiper-pagination-cards .swiper-pagination-bullet");
      const n = bullets.length;
      $config.numeracaoTotal.innerText = (n < 10) ? "0" + n : n;
    },
  };

  const swiper = new Swiper(container, {
    slidesPerView: 1,
    spaceBetween: 16,
   /* loop: true,
    allowTouchMove: true,*/
    navigation: {
      nextEl: '.swiper-sobmedida-next',
      prevEl: '.swiper-sobmedida-prev',
    },
    pagination: {
      el: '.swiper-pagination-cards',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },
    on: {
      init: () => {
        $config.setNumeracaoTotal();
      },
      slideChange: () => {
        const activeBullet = find(".swiper-pagination-cards .swiper-pagination-bullet.swiper-pagination-bullet-active");
        if (!activeBullet) return;
        const progress = parseInt(activeBullet.getAttribute('aria-label').split("Go to slide ")[1]);
        $config.setNumeracao(progress);
      },
      resize: () => {
        $config.setNumeracaoTotal();
      },
    }
  });

  return swiper;
};

export default initializeSwiperSobMedida;
